import { useQuery } from "@tanstack/react-query";
import { WarehouseRoutingCheckIn } from "src/types/database";
import { WarehouseRoutingCheckInService } from "src/services";
import { queryKeys } from "src/constants";

const usePurchaseOrderRoutingCheckIns = (
  purchaseOrderId: string | undefined,
  routingCheckInService: WarehouseRoutingCheckInService
) => {
  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey: queryKeys.warehouseRoutingCheckIns(purchaseOrderId),
    queryFn: () => routingCheckInService.getAllByPurchaseOrderId(purchaseOrderId as string),
    enabled: Boolean(purchaseOrderId),
    retry: false
  });

  const routingCheckIns: WarehouseRoutingCheckIn[] = data ?? [];

  return {
    routingCheckIns,
    isLoading,
    isFetching,
    fetchError: error,
    refetch
  };
};

export { usePurchaseOrderRoutingCheckIns };
